import { Field } from 'react-final-form';
import { useTranslation } from '../../../../utils/useTranslation';
import { WithHint } from '../../../feedback/Tooltip';
import { FormControl } from '../../../input/FormControl';
import { Input } from '../../../input/Input';
import { Typography } from '../../../typography/Typography';
import {
    BUSINESS_ACCOUNT_TEXT,
    SERVICE_ACCOUNT_TEXT,
} from '../../BusinessRegistrationAccount/constants';
import { BusinessRegistrationHeader } from '../../BusinessRegistrationHeader/BusinessRegistrationHeader';
import { BusinessRegistrationType } from '../../BusinessRegistrationType/BusinessRegistrationType';
import { BusinessType } from '../../types';
import { textDictionary, validateDisplayName, validateDomain, validateUrl } from '../constants';
import { LinkField } from './LinkField';
import { SocialLinkFields } from './SocialLinkFields';

export const BusinessFields = ({
    isService,
    onFieldBlur,
    onChangeTypeClick,
}: {
    onFieldBlur: (name: string, value: string) => void;
    isService?: boolean;
    onChangeTypeClick?: VoidFunction;
}) => {
    const t = useTranslation();
    const textMap = textDictionary[BusinessType.BUSINESS];

    return (
        <>
            <BusinessRegistrationHeader
                typeSlot={
                    <BusinessRegistrationType
                        my={2}
                        {...(isService ? SERVICE_ACCOUNT_TEXT : BUSINESS_ACCOUNT_TEXT)}
                        onClick={onChangeTypeClick}
                    />
                }
            />
            <Typography variant="body">{t(textMap.registerDisclaimer)}</Typography>
            {isService ? (
                <>
                    <Typography variant="title3" weight="bold" py={2} mt={1}>
                        {t('Сайт')}
                    </Typography>
                    <Typography variant="body">
                        {t(
                            'Укажите сайт с возможностью для онлайн-записи. Cсылка будет отображаться в бизнес-аккаунте и во всех опубликованных постах',
                        )}
                    </Typography>
                </>
            ) : null}
            <Field
                name="domain"
                validate={validateDomain}
                render={({ input, meta }) => (
                    <FormControl
                        pt={3}
                        pb={1}
                        label={t('Укажите сайт')}
                        required
                        error={
                            (meta.touched && Boolean(meta.error)) ||
                            (!meta.modifiedSinceLastSubmit && Boolean(meta.submitError))
                                ? true
                                : undefined
                        }
                        message={
                            (meta.modifiedSinceLastSubmit ? undefined : meta.submitError) ||
                            (meta.touched ? meta.error : undefined)
                        }
                    >
                        <Input
                            {...input}
                            type="text"
                            autoComplete="off"
                            placeholder="https://"
                            onBlur={(event) => {
                                onFieldBlur('domain', event.target.value);
                                input.onBlur(event);
                            }}
                        />
                    </FormControl>
                )}
            />

            <Typography variant="title3" weight="bold" py={2}>
                <WithHint message={t(textMap.socialLinksHint)}>{t(textMap.socialLinks)}</WithHint>
            </Typography>
            <SocialLinkFields businessType={BusinessType.BUSINESS} onFieldBlur={onFieldBlur} />

            <LinkField
                name="otherUrl"
                validate={validateUrl}
                label={t('Ссылка на ваш профиль на любом другом ресурсе')}
                placeholder="https://"
                onFieldBlur={onFieldBlur}
            />
            <Typography variant="title3" weight="bold" py={2}>
                {isService ? t('Информация о бизнесе/специалисте') : t('Информация о бизнесе')}
            </Typography>
            <Field
                name="displayName"
                validate={validateDisplayName}
                render={({ input, meta }) => (
                    <FormControl
                        py={1}
                        required
                        label={t('Название профиля')}
                        error={
                            (meta.touched && Boolean(meta.error)) ||
                            (!meta.modifiedSinceLastSubmit && Boolean(meta.submitError))
                                ? true
                                : undefined
                        }
                        message={
                            (meta.modifiedSinceLastSubmit ? undefined : meta.submitError) ||
                            (meta.touched ? meta.error : undefined)
                        }
                    >
                        <Input
                            {...input}
                            type="text"
                            autoComplete="off"
                            placeholder={t('Не заполнено')}
                            onBlur={(event) => {
                                onFieldBlur('displayName', event.target.value);
                                input.onBlur(event);
                            }}
                        />
                    </FormControl>
                )}
            />
            <LinkField
                name="email"
                required
                disabled
                label={t('Адрес электронной почты')}
                placeholder="Не заполнено"
                onFieldBlur={onFieldBlur}
            />
            <Typography variant="caption" color="secondary">
                {t('На вашу почту мы будем присылать важные уведомления от сервиса')}
            </Typography>
        </>
    );
};
